'use strict';
module.exports = function GoldAttachmentPicker(filePicker, pageState, resourceManager, optional) {
	const obj = this,
		subscriptionModel = optional?.subscriptionModel;
	let allowAttachments;
	if (subscriptionModel) {
		subscriptionModel.addEventListener('subscribed', () => {
			allowAttachments = true;
		});
		subscriptionModel.addEventListener('not-authenticated expiredSubscription notRegistered', () => {
			allowAttachments = false;
		});
	} else {
		allowAttachments = true;
	}
	obj.pickAttachment = function (options) {
		if (!allowAttachments) {
			return Promise.reject('not-subscribed');
		}
		return filePicker.pickFile().then((result) => {
			const shouldUploadAssets = pageState.getAllowedActions().uploadChanges;
			if (!shouldUploadAssets) {
				return {
					content: result.contents,
					contentType: result.type,
					dataUriEncoded: true,
					name: result.name
				};
			} else {
				if (options && options.notify) {
					options.notify('uploading', result.name);
				}
				return resourceManager.addGoldAsset(result.contents).then((resourceId) => {
					return {
						goldAssetId: resourceId,
						name: result.name,
						contentType: result.type
					};
				});
			}
		});
	};
};

